import { DialogProps } from "../../types/dialog-types";
import tigerIconUrl from "../../assets/tiger-icon.ico?url";
import { getTigerResource } from "../../utils/tigerResource";
import { acrylicStyles, acrylicTokens } from "../../theme/acrylic";

export interface AboutDialogProps extends DialogProps {
  version?: string;
}

const styles = {
  ...acrylicStyles,
  // Plain flex-centred overlay card (not absolute-positioned): keep the
  // centering mechanics and restyle only the surface to acrylic.
  overlay: {
    ...acrylicStyles.overlay,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  dialog: {
    background: acrylicTokens.surface,
    backdropFilter: acrylicTokens.surfaceBlur,
    WebkitBackdropFilter: acrylicTokens.surfaceBlur,
    border: acrylicTokens.surfaceBorder,
    borderRadius: acrylicTokens.surfaceRadius,
    width: 420,
    maxWidth: "92vw",
    boxShadow: acrylicTokens.surfaceShadow,
    overflow: "hidden" as const,
  },
  body: {
    padding: "24px 24px 20px",
    display: "flex",
    flexDirection: "column" as const,
    alignItems: "center",
    gap: 12,
  },
  logo: {
    width: 72,
    height: 72,
    objectFit: "contain" as const,
    imageRendering: "auto" as const,
  },
  productName: {
    fontSize: 15,
    fontWeight: 600,
    color: "#1a1d24",
    margin: 0,
  },
  version: {
    fontSize: 13,
    color: "#4b5260",
    margin: 0,
  },
  copyright: {
    fontSize: 11,
    color: "#4b5260",
    margin: 0,
  },
} as const;

export function AboutDialog({
  open,
  onClose,
  version = "12.0",
}: AboutDialogProps) {
  if (!open) return null;

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div
        style={styles.dialog}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-label={getTigerResource("TIGER_ABOUT_TITLE")}
      >
        {/* Header */}
        <div style={styles.header}>
          <span style={styles.title}>{getTigerResource("TIGER_ABOUT_TITLE")}</span>
          <button className="acrylic-close-btn" onClick={onClose}>
            &#x2715;
          </button>
        </div>

        {/* Body */}
        <div style={styles.body}>
          <img src={tigerIconUrl} alt={getTigerResource("TIGER_ABOUT_LOGO")} style={styles.logo} />
          <p style={styles.productName}>{getTigerResource("TIGER_ABOUT_TIGER")}</p>
          <p style={styles.version}>{getTigerResource("TIGER_ABOUT_RUNTIME")}{version}</p>
          <p style={styles.copyright}>{getTigerResource("TIGER_ABOUT_TRADEMARK")}</p>
        </div>

        {/* Footer */}
        <div style={styles.footer}>
          <button className="btn-acrylic-primary" onClick={onClose}>
            {getTigerResource("TIGER_RES_OK")}
          </button>
        </div>
      </div>
    </div>
  );
}
